import { useState } from "react";
import { ButtonSubmit } from "../ButtonSubmit";
import { InputGlobal } from "../InputGlobal";
import { validateEmail } from "../../helpers";
import LoaderEmail from "../LoaderEmail";

import "./Email.scss";
// import { VideoMobile } from "../VideoMobile";

export const Email = ({ data, setData, nextStep }) => {
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState("");
  const [loaderTextMain, setLoaderTextMain] = useState("");
  const [loaderTextSub, setLoaderTextSub] = useState("");
  const domains = [
    "@gmail.com",
    "@yahoo.com",
    "@hotmail.com",
    "@aol.com",
    "@outlook.com",
    "@comcast.net",
    "@live.com",
    "@mail.com",
    "@msn.com",
    "@att.net",
    "@icloud.com",
  ];

  const handlerSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    setLoaderTextMain("Checking your email...");
    setLoaderTextSub("This might take a moment.");

    const textTimeout = setTimeout(() => {
      setLoaderTextMain("Still checking your email...");
      setLoaderTextSub("Thanks for your patience!");
    }, 3000);

    validateEmail(value, (result) => {
      clearTimeout(textTimeout);
      setLoader(false);
      setLoaderTextMain("");
      setLoaderTextSub("");
      const { status, error } = result;
      setLoader(false);
      if (!status) {
        setErrorEmail(error);
      } else {
        setData({ ...data, email: value });
        nextStep();
      }
    });
  };

  const handleAddEmail = (e) => {
    setEmailValue(e.target.value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setValue(value);
  };

  return (
    <div className="global__wrapper">
      {/* <VideoMobile /> */}
      <form className="form__global" onSubmit={handlerSubmit}>
        {loader && (
          <LoaderEmail textMain={loaderTextMain} textSub={loaderTextSub} />
        )}
        <h3 className="title__global email">What's your email?</h3>
        <div className="has-float-label">
          <InputGlobal
            className={
              "input__global" +
              (errorEmail ? " error" : "") +
              (value.length > 0 && !value.includes("@") ? " active" : "")
            }
            onChange={(e) => handleAddEmail(e)}
            name={"name"}
            placeholder={"Your email"}
            type={"text"}
            id={"name"}
            value={value}
          />
          {value.length > 0 && !value.includes("@") && (
            <div className="autocomplete__box">
              <ul className="autocomplete__box-list">
                {domains.map((items, index) => (
                  <li
                    onClick={() => setValue(value + items)}
                    className="autocomplete__box-list-item"
                    key={index}
                  >
                    {value}
                    {items}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <label htmlFor="name" className={errorEmail ? "error" : ""}>
            Your email
          </label>
          {errorEmail && <p className="error-text">{errorEmail}</p>}
        </div>

        {errorEmail && <p className="error-text">{errorEmail}</p>}
        <ButtonSubmit className={"button"} text={"Continue"} />
      </form>
    </div>
  );
};
